import {Component, OnInit} from '@angular/core';
import moment from 'moment';
import {Field, TrailerIntervention, TrailerOperationType} from 'shared';
import {FieldService} from '../../stores/field.service';
import {TimePieChartEntry} from '../../reports/charts/time-pie-chart/time-pie-chart.component';

export class FieldsGeneralReportRequest {
  from: Date;
  to: Date;
  isToday: boolean;
  field: Field;
  trailerOperationType: TrailerOperationType[] = [];

  constructor() {
    this.from = moment().startOf('day').toDate();
    this.to = moment().endOf('day').toDate();
    this.isToday = true;
  }
}

@Component({
  selector: 'app-fields-general-report',
  templateUrl: './fields-general-report.component.html',
  styleUrls: ['./fields-general-report.component.scss']
})
export class FieldsGeneralReportComponent implements OnInit {

  request = new FieldsGeneralReportRequest();
  loadingVisible = false;
  summary = [];
  all = [];
  timeReports = new Map<number, TimePieChartEntry[]>();

  constructor(
    private fieldService: FieldService,
  ) {
  }

  ngOnInit(): void {
  }

  load(request: FieldsGeneralReportRequest) {
    this.loadingVisible = true;
    this.fieldService.trailerInterventionsReport(
      request.field.id,
      request.from,
      request.to,
      request.trailerOperationType.map(o => o.id)
    ).subscribe((d: any) => {
      this.loadingVisible = false;
      console.log(d);
      Object.keys(d.summary).forEach(k => {
        const inter = new TrailerIntervention(d.summary[k]);
        this.timeReports.set(inter.id, [
          {name: 'Travail', duration: inter.drive_working_duration},
          {name: 'Arrêt', duration: inter.stop_working_duration},
          {name: 'Trajet', duration: inter.total_road_duration},
        ]);
        this.summary.push({
          key: k,
          items: [inter]
        });
      });
    });
  }
}
